import React from 'react';
import { useAuth } from '../../context/AuthContext';

const VECIIdentitas = ({ identity }) => {
  const { authUser } = useAuth();
  if (!identity) return null;

  const isBumdes = authUser?.activeSession?.roleName === 'Bumdes';

  const { projectOfficer, supervisor, surveyContext, bumdes } = identity;

  const dataDisplay = {
    poName: projectOfficer?.name || 'Admin BCF',
    bumdesName: bumdes?.name || '',
    regency: bumdes?.regency || '',
    province: bumdes?.province || '',
    establishedYear: bumdes?.establishedYear || '',
    registrationNumber: bumdes?.registrationNumber || '',
    bumdesType: bumdes?.type || '',
    supervisorName: supervisor?.name || 'Administrator',
    phase:
      surveyContext.phase === 'T1'
        ? 'T1 (Baseline)'
        : surveyContext.phase === 'T2'
          ? 'T2 (Endline)'
          : 'T0 (Pra-Survey)',
    surveyDate: new Date().toLocaleDateString('id-ID', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }),
  };

  return (
    <div className='card border-0 shadow-sm rounded-4 p-4 p-md-5 animate-slide-up bg-white'>
      <div className='d-flex align-items-center mb-4 border-bottom pb-3'>
        <div className='bg-primary bg-opacity-10 p-3 rounded-4 me-3'>
          <i className='bi bi-clipboard2-check text-primary fs-3'></i>
        </div>
        <div>
          <h4 className='fw-bold mb-0'>Identitas & Validasi Form</h4>
          <p className='text-muted small mb-0'>
            Verifikasi data BUMDes dan Petugas Lapangan
          </p>
        </div>
      </div>

      <div className='row g-4'>
        {/* Row 1: Project Officer & Supervisor */}
        <div className='col-md-6'>
          <label className='form-label small text-muted text-uppercase fw-bold mb-1'>
            Nama Project Officer
          </label>
          <div className='p-3 bg-light rounded-3 border-2 border-dashed text-dark d-flex align-items-center gap-2'>
            <i className='bi bi-person-badge text-primary'></i>{' '}
            {dataDisplay.poName}
          </div>
        </div>
        <div className='col-md-6'>
          <label className='form-label small text-muted text-uppercase fw-bold mb-1'>
            Nama Supervisor BCF
          </label>
          <div className='p-3 bg-light rounded-3 border-2 border-dashed text-dark d-flex align-items-center gap-2'>
            <i className='bi bi-person-check text-info'></i>{' '}
            {dataDisplay.supervisorName}
          </div>
        </div>

        {/* Row 2: BUMDes Main Info */}
        <div className='col-md-6'>
          <label className='form-label small text-muted text-uppercase fw-bold mb-1'>
            Nama BUMDes
          </label>
          <div className='p-3 bg-light rounded-3 border-2 border-dashed fw-bold text-dark d-flex align-items-center gap-2'>
            <i className='bi bi-building text-primary'></i>{' '}
            {dataDisplay.bumdesName}
          </div>
        </div>
        <div className='col-md-6'>
          <label className='form-label small text-muted text-uppercase fw-bold mb-1'>
            Nomor Registrasi BUMDes
          </label>
          <div className='p-3 bg-light rounded-3 border-2 border-dashed text-dark d-flex align-items-center gap-2'>
            <i className='bi bi-hash text-warning'></i>{' '}
            {dataDisplay.registrationNumber}
          </div>
        </div>

        {/* Row 3: Location */}
        <div className='col-md-6'>
          <label className='form-label small text-muted text-uppercase fw-bold mb-1'>
            Kabupaten / Kota
          </label>
          <div className='p-3 bg-light rounded-3 border-2 border-dashed text-dark d-flex align-items-center gap-2'>
            <i className='bi bi-geo-alt text-danger'></i> {dataDisplay.regency}
          </div>
        </div>
        <div className='col-md-6'>
          <label className='form-label small text-muted text-uppercase fw-bold mb-1'>
            Provinsi
          </label>
          <div className='p-3 bg-light rounded-3 border-2 border-dashed text-dark d-flex align-items-center gap-2'>
            <i className='bi bi-map text-success'></i> {dataDisplay.province}
          </div>
        </div>

        {/* Row 4: Establishment & Type */}
        <div className='col-md-4'>
          <label className='form-label small text-muted text-uppercase fw-bold mb-1'>
            Tahun Berdiri
          </label>
          <div className='p-3 bg-light rounded-3 border-2 border-dashed text-dark d-flex align-items-center gap-2'>
            <i className='bi bi-calendar-check text-info'></i>{' '}
            {dataDisplay.establishedYear}
          </div>
        </div>
        <div className='col-md-4'>
          <label className='form-label small text-muted text-uppercase fw-bold mb-1'>
            Jenis BUMDes
          </label>
          <div className='p-3 bg-light rounded-3 border-2 border-dashed text-dark d-flex align-items-center gap-2'>
            <i className='bi bi-tags text-secondary'></i>{' '}
            {dataDisplay.bumdesType}
          </div>
        </div>
        <div className='col-md-4'>
          <label className='form-label small text-muted text-uppercase fw-bold mb-1'>
            Tahapan Survey
          </label>
          <div className='p-3 bg-light rounded-3 border-2 border-dashed text-primary fw-bold d-flex align-items-center gap-2'>
            <i className='bi bi-calendar-event'></i> {dataDisplay.phase}
          </div>
        </div>
      </div>

      {!isBumdes && (
        <div className='mt-5 p-4 bg-success bg-opacity-10 rounded-4 border border-success border-opacity-25'>
          <div className='d-flex gap-3'>
            <i className='bi bi-shield-check text-success fs-2'></i>
            <div>
              <h6 className='fw-bold text-success mb-1'>
                Status Validasi: AKTIF
              </h6>
              <p className='text-success small mb-0 opacity-75'>
                Anda telah terverifikasi sebagai PO resmi untuk BUMDes ini. Data
                identitas di atas telah dikunci untuk menjaga integritas survei.
                Silakan klik 'Selanjutnya' untuk mulai mengisi Profil Direktur BUMDesa.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VECIIdentitas;
